
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8fa5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8fa5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hILQm", function(module, exports) {

$parcel$export(module.exports, "getIndexFromCoordinate", function () { return $39d77dc9061dc528$export$e3efb7bf0716ec07; });
$parcel$export(module.exports, "Canvas", function () { return $39d77dc9061dc528$export$8d01c972ee8b14a9; });
const $39d77dc9061dc528$var$colorRange = 256;
const $39d77dc9061dc528$var$canvasSize = 4096;
let $39d77dc9061dc528$var$speed = 200;
let $39d77dc9061dc528$var$backupIndices;
let $39d77dc9061dc528$var$backupImage;
function $39d77dc9061dc528$export$e3efb7bf0716ec07([x, y]) {
    return $39d77dc9061dc528$var$canvasSize * y + x;
}
function $39d77dc9061dc528$export$95941ac9d46aa23e(index) {
    return [
        index % $39d77dc9061dc528$var$canvasSize,
        Math.floor(index / $39d77dc9061dc528$var$canvasSize)
    ];
}
function $39d77dc9061dc528$export$8d01c972ee8b14a9(containerEl) {
    if (!containerEl) throw new Error('Element not found!');
    const canvas = document.createElement('canvas');
    canvas.width = $39d77dc9061dc528$var$canvasSize;
    canvas.height = $39d77dc9061dc528$var$canvasSize;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Could not create canvas context!');
    context.imageSmoothingEnabled = false;
    context.clearRect(0, 0, canvas.width, canvas.height);
    let image = context.createImageData(canvas.width, canvas.height);
    let data = image.data;
    function clearCanvas() {
        if (!context) throw new Error('Could not create canvas context!');
        context.clearRect(0, 0, canvas.width, canvas.height);
        image = context.createImageData(canvas.width, canvas.height);
        data = image.data;
    }
    function drawPixelToBuffer(coordinateIndex, pixelsDrawnCount) {
        const color = getColor(pixelsDrawnCount);
        const index = 4 * coordinateIndex;
        data[index] = color.r;
        data[index + 1] = color.g;
        data[index + 2] = color.b;
        data[index + 3] = 255;
    }
    function pixelEmpty(coordinateIndex) {
        const index = 4 * coordinateIndex;
        return data[index + 3] === 0;
    }
    function drawBuffer() {
        context?.putImageData(image, 0, 0);
    }
    const pixel = new ImageData(1, 1);
    function swapPixel(coordinateIndex, pixelsDrawnCount, force) {
        const index = 4 * coordinateIndex;
        // Check if pixel already drawn
        if (!force && data[index + 3] !== 0) return;
        const color = getColor(pixelsDrawnCount);
        data[index] = color.r;
        data[index + 1] = color.g;
        data[index + 2] = color.b;
        data[index + 3] = 255;
        pixel.data[0] = color.r;
        pixel.data[1] = color.g;
        pixel.data[2] = color.b;
        pixel.data[3] = 255;
        const coordinate = $39d77dc9061dc528$export$95941ac9d46aa23e(coordinateIndex);
        context?.putImageData(pixel, coordinate[0], coordinate[1]);
    }
    function erasePixel(coordinateIndex) {
        const index = 4 * coordinateIndex;
        pixel.data[0] = 0;
        pixel.data[1] = 0;
        pixel.data[2] = 0;
        pixel.data[3] = 0;
        data[index + 3] = 0;
        const coordinate = $39d77dc9061dc528$export$95941ac9d46aa23e(coordinateIndex);
        context?.putImageData(pixel, coordinate[0], coordinate[1]);
    }
    const multi = $39d77dc9061dc528$var$colorRange * $39d77dc9061dc528$var$colorRange;
    function getColor(index) {
        return {
            r: Math.floor(index / multi % $39d77dc9061dc528$var$colorRange),
            g: Math.floor(index / $39d77dc9061dc528$var$colorRange % $39d77dc9061dc528$var$colorRange),
            b: index % $39d77dc9061dc528$var$colorRange
        };
    }
    // Streaming: draw a chunk of pixels starting at a global offset
    let streamIndices = [];
    let drawBufferRaf = 0;
    function drawChunk(indices, offset) {
        for(let i = 0; i < indices.length; i++)drawPixelToBuffer(indices[i], offset + i);
        streamIndices.push(...indices);
        if (!drawBufferRaf) drawBufferRaf = requestAnimationFrame(()=>{
            drawBufferRaf = 0;
            drawBuffer();
        });
    }
    function finalizeStream() {
        $39d77dc9061dc528$var$backupIndices = streamIndices;
        $39d77dc9061dc528$var$backupImage = image;
    }
    let counter = 0;
    let animating = false;
    function handleAnimationComplete() {
        animating = false;
        if ($39d77dc9061dc528$var$backupImage) {
            image = $39d77dc9061dc528$var$backupImage;
            drawBuffer();
        }
    }
    function animate(cb, onUpdate) {
        let runToLength = $39d77dc9061dc528$var$backupIndices.length - 1;
        function innerAnimate() {
            for(let i = 0; i < $39d77dc9061dc528$var$speed; i++)if (counter < runToLength) {
                swapPixel($39d77dc9061dc528$var$backupIndices[counter], counter);
                counter++;
            }
            if (animating && counter < runToLength) {
                if (onUpdate) onUpdate(counter);
                window.requestAnimationFrame(innerAnimate);
            } else if (cb) cb();
        }
        innerAnimate();
    }
    function startAnimation(cb, onUpdate) {
        if (!$39d77dc9061dc528$var$backupImage) $39d77dc9061dc528$var$backupImage = image;
        clearCanvas();
        animating = true;
        counter = 0;
        animate(cb, onUpdate);
    }
    containerEl.appendChild(canvas);
    return {
        canvas: canvas,
        pixelEmpty: pixelEmpty,
        drawImmediate (coordinateIndex, pixelsDrawnCount, force) {
            swapPixel(coordinateIndex, pixelsDrawnCount, force);
        },
        erase (coordinateIndex) {
            erasePixel(coordinateIndex);
        },
        drawChunk: drawChunk,
        finalizeStream: finalizeStream,
        getColor: getColor,
        startAnimation: startAnimation,
        stopAnimation: handleAnimationComplete,
        totalPixels: canvas.width * canvas.height
    };
}

});

parcelRegister("ixVcj", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return $f73fe222e1948c80$export$4798917dbf149b79; });
function $f73fe222e1948c80$export$4798917dbf149b79({ hostname: hostname, onOpen: onOpen, onMessage: onMessage }) {
    const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const serverUrl = `${scheme}://${hostname}`;
    let timeout = 250;
    let socket;
    let buffer = [];
    let flushScheduled = false;
    function flush() {
        flushScheduled = false;
        if (!socket || socket.readyState !== 1 || buffer.length === 0) return;
        if (buffer.length === 1) socket.send(JSON.stringify(buffer[0]));
        else socket.send(JSON.stringify(buffer));
        buffer = [];
    }
    const connect = ()=>{
        socket = new WebSocket(serverUrl);
        socket.addEventListener('open', ()=>{
            console.log('connected');
            timeout = 250;
            if (onOpen) onOpen(socket);
        });
        socket.addEventListener('error', ()=>{
            console.error('Error with socket connection');
            socket?.close();
        });
        socket.addEventListener('close', ()=>{
            timeout = Math.min(30000, timeout * 2);
            const jitter = timeout * (0.8 + Math.random() * 0.4);
            console.log('We disconnected from the socket, retrying in', Math.round(jitter));
            setTimeout(connect, jitter);
        });
        socket.addEventListener('message', (event)=>{
            if (onMessage) onMessage(event.data);
        });
        return socket;
    };
    connect();
    return {
        send: (coordinateIndex)=>{
            buffer.push(coordinateIndex);
            if (!flushScheduled) {
                flushScheduled = true;
                requestAnimationFrame(flush);
            }
        },
        sendRaw: (data)=>{
            if (!socket || socket.readyState !== 1) return;
            socket.send(data);
        }
    };
}

});


var $hILQm = parcelRequire("hILQm");

var $ixVcj = parcelRequire("ixVcj");
function $a06697c681a55710$var$hide(el) {
    el?.classList.add('hidden');
}
function $a06697c681a55710$var$show(el) {
    el?.classList.remove('hidden');
}
function $a06697c681a55710$var$isHidden(el) {
    return el?.classList.contains('hidden');
}
function $a06697c681a55710$var$toggleVisibilty(el, force) {
    el?.classList.toggle('hidden', !force);
}
function $a06697c681a55710$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
function $a06697c681a55710$export$4b08aed5f1ec6952(canvas) {
    const el = {
        touchMessage: document.getElementById('touch'),
        processButton: document.getElementById('processBtn'),
        creditsButton: document.getElementById('creditsBtn'),
        loading: document.getElementById('loading'),
        credits: document.getElementById('credits'),
        textContainer: document.getElementById('text-container'),
        pixelsDrawn: document.getElementById('pixelsDrawn'),
        pixelsRemaining: document.getElementById('pixelsRemaining'),
        error: document.getElementById('error'),
        r: document.getElementById('red'),
        g: document.getElementById('green'),
        b: document.getElementById('blue')
    };
    let animating = false;
    let hasShownTouchMessage = false;
    let returnCount = 0;
    const isLoading = ()=>{
        return !$a06697c681a55710$var$isHidden(el.loading);
    };
    const setLoading = (loading)=>{
        $a06697c681a55710$var$toggleVisibilty(el.loading, loading);
        $a06697c681a55710$var$toggleVisibilty(el.textContainer, !loading);
        if (!hasShownTouchMessage && !loading && $a06697c681a55710$var$isTouchDevice()) {
            hasShownTouchMessage = true;
            $a06697c681a55710$var$show(el.touchMessage);
        }
    };
    const toggleCredits = ()=>{
        el.creditsButton?.classList.toggle('active', $a06697c681a55710$var$isHidden(el.credits));
        $a06697c681a55710$var$toggleVisibilty(el.credits, $a06697c681a55710$var$isHidden(el.credits));
    };
    el.creditsButton?.addEventListener('click', toggleCredits);
    el.processButton?.addEventListener('click', toggleAnimation);
    function checkTouchMessage() {
        if (hasShownTouchMessage) {
            $a06697c681a55710$var$hide(el.touchMessage);
            hasShownTouchMessage = false;
        }
    }
    // UPDATE INFO TEXT
    function updateText(pixelsDrawnCount, force) {
        if (isNaN(pixelsDrawnCount)) return;
        if (animating && !force) return;
        if (el.pixelsDrawn) el.pixelsDrawn.textContent = `${pixelsDrawnCount}`;
        if (el.pixelsRemaining) el.pixelsRemaining.textContent = `${canvas.totalPixels - pixelsDrawnCount}`;
        const color = canvas.getColor(pixelsDrawnCount);
        if (el.r) el.r.textContent = `${color.r}`;
        if (el.g) el.g.textContent = `${color.g}`;
        if (el.b) el.b.textContent = `${color.b}`;
        if (!animating) returnCount = pixelsDrawnCount;
    }
    function onStartAnimation() {
        animating = true;
        el.processButton?.classList.add('active');
    }
    function onStopAnimation() {
        animating = false;
        el.processButton?.classList.remove('active');
        updateText(returnCount);
    }
    function forceUpdateText(count) {
        updateText(count, true);
    }
    function stopAnimation() {
        canvas.stopAnimation();
        onStopAnimation();
    }
    function toggleAnimation() {
        if (!animating) {
            if (isLoading()) return;
            onStartAnimation();
            canvas.startAnimation(onStopAnimation, forceUpdateText);
        } else stopAnimation();
    }
    function loopProcess() {
        if (isLoading()) return;
        canvas.startAnimation(loopProcess, forceUpdateText);
        onStartAnimation();
    }
    function setLoadingError() {
        setLoading(false);
        $a06697c681a55710$var$show(el.error);
    }
    return {
        checkTouchMessage: checkTouchMessage,
        updateText: updateText,
        setLoading: setLoading,
        toggleAnimation: toggleAnimation,
        loopProcess: loopProcess,
        stopAnimation: stopAnimation,
        isAnimating () {
            return animating;
        },
        isLoading: isLoading,
        setLoadingError: setLoadingError
    };
}


let $092da5ab68c62f1f$var$previewDrawnCount = 0;
const $092da5ab68c62f1f$var$canvas = (0, $hILQm.Canvas)(document.getElementById('canvas'));
const $092da5ab68c62f1f$var$ui = (0, $a06697c681a55710$export$4b08aed5f1ec6952)($092da5ab68c62f1f$var$canvas);
$092da5ab68c62f1f$var$ui.setLoading(true);
// ADD SOCKET LISTENERS
const $092da5ab68c62f1f$var$hostname = window.location.hostname + `:${window.location.port}`;
const $092da5ab68c62f1f$var$socket = (0, $ixVcj.Socket)({
    hostname: $092da5ab68c62f1f$var$hostname,
    onOpen: ()=>{
        fetch(window.location.protocol + '//' + $092da5ab68c62f1f$var$hostname + '/api/data').then(async (res)=>{
            if (!res.ok) throw new Error('Failed to load pixel data');
            const reader = res.body.getReader();
            let remainder = new Uint8Array(0);
            let totalPixels = 0;
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                // Concat leftover bytes from previous chunk with new data
                const combined = new Uint8Array(remainder.length + value.length);
                combined.set(remainder);
                combined.set(value, remainder.length);
                // Process complete 3-byte triplets
                const usable = combined.length - combined.length % 3;
                const count = usable / 3;
                const chunk = new Array(count);
                for(let i = 0; i < count; i++)chunk[i] = combined[i * 3] << 16 | combined[i * 3 + 1] << 8 | combined[i * 3 + 2];
                $092da5ab68c62f1f$var$canvas.drawChunk(chunk, totalPixels);
                totalPixels += count;
                $092da5ab68c62f1f$var$ui.setLoading(false);
                $092da5ab68c62f1f$var$ui.updateText(totalPixels);
                // Keep leftover bytes for next iteration
                remainder = combined.slice(usable);
            }
            $092da5ab68c62f1f$var$canvas.finalizeStream();
            $092da5ab68c62f1f$var$previewDrawnCount = totalPixels;
            if ($092da5ab68c62f1f$var$processMode) $092da5ab68c62f1f$var$ui.loopProcess();
        }).catch(()=>{
            $092da5ab68c62f1f$var$ui.setLoadingError();
        });
    },
    onMessage: (message)=>{
        const parsedMessage = JSON.parse(message);
        if (!parsedMessage?.length || parsedMessage.length !== 3) return;
        const [coordinateIndex, pixelsDrawnCount, owner] = parsedMessage;
        $092da5ab68c62f1f$var$canvas.drawImmediate(parseInt(coordinateIndex, 10), pixelsDrawnCount, true);
        $092da5ab68c62f1f$var$ui.updateText(pixelsDrawnCount);
        if (owner !== 1) $092da5ab68c62f1f$var$previewDrawnCount = pixelsDrawnCount;
    }
});
// PROCESS MODE
let $092da5ab68c62f1f$var$processMode = window.location.search === '?process';
function $092da5ab68c62f1f$var$toggleProcessMode() {
    if ($092da5ab68c62f1f$var$processMode) {
        $092da5ab68c62f1f$var$ui.stopAnimation();
        window.location.search = '';
    } else window.location.search = 'process';
}
// DEMO MODE
let $092da5ab68c62f1f$var$demoMode = window.location.search === '?demo';
let $092da5ab68c62f1f$var$demoTimer;
let $092da5ab68c62f1f$var$demoTime = 15000; // 15 seconds
let $092da5ab68c62f1f$var$demoX = 0;
let $092da5ab68c62f1f$var$demoY = 0;
function $092da5ab68c62f1f$var$toggleDemoMode() {
    window.location.search = $092da5ab68c62f1f$var$demoMode ? '' : 'demo';
}
function $092da5ab68c62f1f$var$checkDemoTimer() {
    if (!$092da5ab68c62f1f$var$demoMode) return;
    clearTimeout($092da5ab68c62f1f$var$demoTimer);
    $092da5ab68c62f1f$var$demoTimer = window.setTimeout(()=>{
        window.scrollTo({
            top: $092da5ab68c62f1f$var$demoY,
            left: $092da5ab68c62f1f$var$demoX,
            behavior: 'smooth'
        });
    }, $092da5ab68c62f1f$var$demoTime);
}
if ($092da5ab68c62f1f$var$demoMode) window.addEventListener('scroll', $092da5ab68c62f1f$var$checkDemoTimer);
// ACTUAL MOUSE/TOUCH DRAWING
const $092da5ab68c62f1f$var$lastAsks = [];
function $092da5ab68c62f1f$var$checkLastAsks(coordinateIndex) {
    return !$092da5ab68c62f1f$var$lastAsks.includes(coordinateIndex);
}
function $092da5ab68c62f1f$var$updateLastAsks(coordinateIndex) {
    if ($092da5ab68c62f1f$var$lastAsks.length > 10) $092da5ab68c62f1f$var$lastAsks.shift();
    $092da5ab68c62f1f$var$lastAsks.push(coordinateIndex);
}
window.addEventListener('mousemove', (ev)=>{
    if ($092da5ab68c62f1f$var$ui.isAnimating()) return;
    const coordinate = [
        Math.floor(ev.pageX),
        Math.floor(ev.pageY)
    ];
    const coordinateIndex = (0, $hILQm.getIndexFromCoordinate)(coordinate);
    if ($092da5ab68c62f1f$var$canvas.pixelEmpty(coordinateIndex) && $092da5ab68c62f1f$var$checkLastAsks(coordinateIndex)) {
        $092da5ab68c62f1f$var$socket.send(coordinateIndex);
        $092da5ab68c62f1f$var$previewDrawnCount += 1;
        $092da5ab68c62f1f$var$canvas.drawImmediate(coordinateIndex, $092da5ab68c62f1f$var$previewDrawnCount);
    }
    $092da5ab68c62f1f$var$updateLastAsks(coordinateIndex);
    $092da5ab68c62f1f$var$checkDemoTimer();
});
function $092da5ab68c62f1f$export$836ff99bad0a09da(touchEvents) {
    const length = touchEvents.length;
    let x = 0;
    let y = 0;
    for(let i = 0; i < length; i++){
        x += touchEvents[i].clientX;
        y += touchEvents[i].clientY;
    }
    return [
        x / length,
        y / length
    ];
}
let $092da5ab68c62f1f$var$maxX = 4096 - window.innerWidth;
let $092da5ab68c62f1f$var$maxY = 4096 - window.innerHeight;
document.addEventListener('gesturestart', (e)=>e.preventDefault());
document.addEventListener('gesturechange', (e)=>e.preventDefault());
window.addEventListener('touchstart', (ev)=>{
    ev.preventDefault();
    $092da5ab68c62f1f$var$ui.checkTouchMessage();
});
let $092da5ab68c62f1f$var$lastCentroid = null;
let $092da5ab68c62f1f$var$velocityX = 0;
let $092da5ab68c62f1f$var$velocityY = 0;
let $092da5ab68c62f1f$var$momentumRaf = 0;
let $092da5ab68c62f1f$var$isPanning = false;
// Sub-pixel scroll accumulator to avoid integer rounding jitter
let $092da5ab68c62f1f$var$scrollX = 0;
let $092da5ab68c62f1f$var$scrollY = 0;
const $092da5ab68c62f1f$var$FRICTION = 0.92;
const $092da5ab68c62f1f$var$MIN_VELOCITY = 0.5;
const $092da5ab68c62f1f$var$VELOCITY_SMOOTHING = 0.8;
function $092da5ab68c62f1f$var$startMomentum() {
    if ($092da5ab68c62f1f$var$momentumRaf) return;
    $092da5ab68c62f1f$var$momentumRaf = window.requestAnimationFrame($092da5ab68c62f1f$var$tickMomentum);
}
function $092da5ab68c62f1f$var$stopMomentum() {
    if ($092da5ab68c62f1f$var$momentumRaf) {
        cancelAnimationFrame($092da5ab68c62f1f$var$momentumRaf);
        $092da5ab68c62f1f$var$momentumRaf = 0;
    }
    $092da5ab68c62f1f$var$velocityX = 0;
    $092da5ab68c62f1f$var$velocityY = 0;
}
function $092da5ab68c62f1f$var$tickMomentum() {
    $092da5ab68c62f1f$var$momentumRaf = 0;
    $092da5ab68c62f1f$var$velocityX *= $092da5ab68c62f1f$var$FRICTION;
    $092da5ab68c62f1f$var$velocityY *= $092da5ab68c62f1f$var$FRICTION;
    if (Math.abs($092da5ab68c62f1f$var$velocityX) < $092da5ab68c62f1f$var$MIN_VELOCITY && Math.abs($092da5ab68c62f1f$var$velocityY) < $092da5ab68c62f1f$var$MIN_VELOCITY) {
        $092da5ab68c62f1f$var$velocityX = 0;
        $092da5ab68c62f1f$var$velocityY = 0;
        return;
    }
    $092da5ab68c62f1f$var$scrollX = Math.max(0, Math.min($092da5ab68c62f1f$var$maxX, $092da5ab68c62f1f$var$scrollX + $092da5ab68c62f1f$var$velocityX));
    $092da5ab68c62f1f$var$scrollY = Math.max(0, Math.min($092da5ab68c62f1f$var$maxY, $092da5ab68c62f1f$var$scrollY + $092da5ab68c62f1f$var$velocityY));
    window.scrollTo({
        left: Math.round($092da5ab68c62f1f$var$scrollX),
        top: Math.round($092da5ab68c62f1f$var$scrollY),
        behavior: 'instant'
    });
    $092da5ab68c62f1f$var$momentumRaf = window.requestAnimationFrame($092da5ab68c62f1f$var$tickMomentum);
}
$092da5ab68c62f1f$var$canvas.canvas.addEventListener('touchstart', (ev)=>{
    ev.preventDefault();
    if (ev.touches.length > 1) {
        $092da5ab68c62f1f$var$stopMomentum();
        $092da5ab68c62f1f$var$isPanning = true;
        $092da5ab68c62f1f$var$scrollX = window.scrollX;
        $092da5ab68c62f1f$var$scrollY = window.scrollY;
        $092da5ab68c62f1f$var$lastCentroid = $092da5ab68c62f1f$export$836ff99bad0a09da(ev.targetTouches);
    }
});
window.addEventListener('touchend', (ev)=>{
    if (!(ev.target instanceof HTMLButtonElement)) ev.preventDefault();
});
$092da5ab68c62f1f$var$canvas.canvas.addEventListener('touchend', (ev)=>{
    if (ev.targetTouches.length < 2) {
        $092da5ab68c62f1f$var$lastCentroid = null;
        if ($092da5ab68c62f1f$var$isPanning) {
            $092da5ab68c62f1f$var$isPanning = false;
            $092da5ab68c62f1f$var$startMomentum();
        }
    } else $092da5ab68c62f1f$var$lastCentroid = $092da5ab68c62f1f$export$836ff99bad0a09da(ev.targetTouches);
});
function $092da5ab68c62f1f$var$handlePan(ev) {
    if (ev.targetTouches.length < 2) return;
    const centroid = $092da5ab68c62f1f$export$836ff99bad0a09da(ev.targetTouches);
    if (!$092da5ab68c62f1f$var$lastCentroid) {
        $092da5ab68c62f1f$var$lastCentroid = centroid;
        return;
    }
    const dX = $092da5ab68c62f1f$var$lastCentroid[0] - centroid[0];
    const dY = $092da5ab68c62f1f$var$lastCentroid[1] - centroid[1];
    $092da5ab68c62f1f$var$velocityX = $092da5ab68c62f1f$var$velocityX * $092da5ab68c62f1f$var$VELOCITY_SMOOTHING + dX * (1 - $092da5ab68c62f1f$var$VELOCITY_SMOOTHING);
    $092da5ab68c62f1f$var$velocityY = $092da5ab68c62f1f$var$velocityY * $092da5ab68c62f1f$var$VELOCITY_SMOOTHING + dY * (1 - $092da5ab68c62f1f$var$VELOCITY_SMOOTHING);
    $092da5ab68c62f1f$var$scrollX = Math.max(0, Math.min($092da5ab68c62f1f$var$maxX, $092da5ab68c62f1f$var$scrollX + dX));
    $092da5ab68c62f1f$var$scrollY = Math.max(0, Math.min($092da5ab68c62f1f$var$maxY, $092da5ab68c62f1f$var$scrollY + dY));
    window.scrollTo({
        left: Math.round($092da5ab68c62f1f$var$scrollX),
        top: Math.round($092da5ab68c62f1f$var$scrollY),
        behavior: 'instant'
    });
    $092da5ab68c62f1f$var$lastCentroid = centroid;
}
$092da5ab68c62f1f$var$canvas.canvas.addEventListener('touchmove', (ev)=>{
    ev.preventDefault();
    if (ev.touches.length === 1) {
        if ($092da5ab68c62f1f$var$ui.isAnimating()) return;
        const coordinate = [
            Math.floor(ev.touches[0].pageX),
            Math.floor(ev.touches[0].pageY)
        ];
        const coordinateIndex = (0, $hILQm.getIndexFromCoordinate)(coordinate);
        if ($092da5ab68c62f1f$var$canvas.pixelEmpty(coordinateIndex) && $092da5ab68c62f1f$var$checkLastAsks(coordinateIndex)) {
            $092da5ab68c62f1f$var$socket.send(coordinateIndex);
            $092da5ab68c62f1f$var$previewDrawnCount += 1;
            $092da5ab68c62f1f$var$canvas.drawImmediate(coordinateIndex, $092da5ab68c62f1f$var$previewDrawnCount);
        }
        $092da5ab68c62f1f$var$updateLastAsks(coordinateIndex);
        return;
    }
    $092da5ab68c62f1f$var$handlePan(ev);
}, {
    passive: false
});
// SCROLL COORDINATES
function $092da5ab68c62f1f$var$scrollFromHash() {
    const hash = window.location.hash.replace('#', '');
    const split = hash.split(',');
    if (split.length === 2) {
        const coordinate = split.map((v)=>parseInt(v, 10));
        window.scrollTo(coordinate[0], coordinate[1]);
    } else // scroll to random position
    window.scrollTo(Math.random() * $092da5ab68c62f1f$var$maxX, Math.random() * $092da5ab68c62f1f$var$maxY);
}
window.addEventListener('hashchange', ()=>{
    $092da5ab68c62f1f$var$scrollFromHash();
});
window.addEventListener('resize', ()=>{
    $092da5ab68c62f1f$var$maxX = 4096 - window.innerWidth;
    $092da5ab68c62f1f$var$maxY = 4096 - window.innerHeight;
});
window.addEventListener('keyup', (ev)=>{
    switch(ev.key){
        case 'p':
            $092da5ab68c62f1f$var$toggleProcessMode();
            return;
        case 'd':
            $092da5ab68c62f1f$var$toggleDemoMode();
            return;
        case 't':
            if (!$092da5ab68c62f1f$var$demoMode) return;
            $092da5ab68c62f1f$var$demoX = window.scrollX;
            $092da5ab68c62f1f$var$demoY = window.scrollY;
            return;
        case 's':
            window.location.hash = `${window.scrollX},${window.scrollY}`;
            return;
        case 'g':
            document.body.classList.toggle('largeType');
            return;
    }
});
$092da5ab68c62f1f$var$scrollFromHash();


//# sourceMappingURL=client.a9d615f8.js.map
